var map = {
	"./capacitate-iel.svg": 69540,
	"./certificate.svg": 15212,
	"./cliente-baja.svg": 53573,
	"./hammer.svg": 60363,
	"./id-card-hold.svg": 33371,
	"./id-card.svg": 78203,
	"./iusa-capacita.svg": 95473,
	"./logo-iusa-gray.svg": 41333,
	"./logo-iusa.svg": 38122,
	"./maps-icon.svg": 91232,
	"./money.svg": 54613,
	"./reel-icon.svg": 55932,
	"./star.svg": 3740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87254;